import React from 'react';

const Glossary = props => {
  return (
    <div>
      <dl>
        <dt>advanced assembly</dt>
        <dd>
        Advanced assembling is the process of putting manufactured parts together. For example, a household washing machine is roughly made of an electric motor, transmission, washing tub, control panel and a chassis, so a factory putting those parts together is said to be assembling.
        </dd>

        <dt>assets</dt>
        <dd>
        A business asset is an item of value owned by a company. Business assets span many categories. They can be physical, tangible goods, such as vehicles, real estate, computers, office furniture, and other fixtures, or intangible items, such as intellectual property. (Source: Investopedia)
        </dd>

        <dt>capital expenses</dt>
        <dd>
        Capital expenditures are the amounts that companies use to purchase major physical goods or services that will be used for more than one year. Examples include: (1) plant & equipment purchases; (2) hardware purchase (i.e., computers) and (3) vehicles. (Source: Investopedia)
        </dd>

        <dt>code of conduct</dt>
        <dd>
        A code of conduct is a set of organizational rules or standards regarding organizational values, beliefs, and ethics, as well as matters of legal compliance that govern the conduct of the organization and its members. (Source: Study.com)
        </dd>

        <dt>convertible promissory note</dt>
        <dd>
        A convertible promissory note is a debt security that contains an option in which the note will be converted into a predefined amount of the issuer's shares. (Source: Investopedia)
        </dd>

        <dt>copyrights</dt>
        <dd>
        Copyright refers to the legal right of the owner of intellectual property. In simpler terms, copyright is the right to copy. This means that the original creators of products and anyone they give authorization to are the only ones with the exclusive right to reproduce the work. (Source: Investopedia)
        </dd>

        <dt>cost of goods sold</dt>
        <dd>
        Cost of goods sold (COGS) refers to the direct costs attributable to the production of the goods sold in a company. This amount includes the cost of the materials used in creating the good along with the direct labor costs used to produce the good. It excludes indirect expenses, such as distribution costs and sales force costs. (Source: Investopedia)
        </dd>

        <dt>critical components</dt>
        <dd>
        Uniquely identifiable input, part, piece, assembly or subassembly, system or subsystem, that (1) is required to complete or finish an activity, item, or job, (2) performs a distinctive and necessary function in the operation of a system, or (3) is intended to be included as a part of a finished, packaged, and labeled item. Components are usually removable in one piece and are considered indivisible for a particular purpose or use. (Source: www.businessdictionary.com)
        </dd>

        <dt>debt</dt>
        <dd>
        Debt is an amount of money borrowed by one party from another. Debt is used by many corporations and individuals as a method of making large purchases that they could not afford under normal circumstances. A debt arrangement gives the borrowing party permission to borrow money under the condition that it is to be paid back at a later date, usually with interest. (Source: Investopedia)
        </dd>

        <dt>defendant</dt>
        <dd>
        The person defending or denying; the party against whom relief or recovery is sought in an action or suit, or the accused in a criminal case.
        </dd>

        <dt>distribution</dt>
        <dd>
        The party who initiates a lawsuit by filing a complaint with the clerk of the court against the defendant(s) demanding damages, performance and/or court determination of rights.
        </dd>

        <dt>equity</dt>
        <dd>
        Equity is typically referred to as shareholder equity (also known as shareholders' equity) which represents the amount of money that would be returned to a company’s shareholders if all of the assets were liquidated and all of the company's debt was paid off. (Source: Investopedia)
        </dd>

        <dt>felony</dt>
        <dd>
        A felony is defined as a crime that is considered to be more serious in nature. In criminal law, a felony is a category of crimes that are often classified as the most serious type of offenses. Felonies can be either violent or nonviolent. In general, felonies are punishable by imprisonment for more than one year, in a federal facility as opposed to a local or county jail.
        </dd>

        <dt>financial statements</dt>
        <dd>Financial statements are written records that convey the business activities and the financial performance of a company. Financial statements are often audited by government agencies, accountants, firms, etc. to ensure accuracy and for tax, financing, or investing purposes. Financial statements include:

        1. Balance sheet
        2. Income statement
        3. Cash flow statement

        (Source: Investopedia)
        </dd>

        <dt>fiscal year</dt>
        <dd>A fiscal year is a one year period that companies and governments use for financial reporting and budgeting. A fiscal year is most commonly used for accounting purposes to prepare financial statements. Although a fiscal year can start on January 1st and end on December 31st, not all fiscal years correspond with the calendar year. For example, universities often begin and end their fiscal years, according to the school year. (Source: Investopedia)</dd>

        <dt>gross profit </dt>
        <dd>
        Gross profit is the profit a company makes after deducting the costs associated with making and selling its products, or the costs associated with providing its services. Gross profit will appear on a company's income statement and can be calculated by subtracting the cost of goods sold (COGS) from revenue (sales). These figures can be found on a company's income statement. (Source: Investopedia)
        </dd>

        <dt>incorporated</dt>
        <dd>
        Incorporation is the legal process used to form a corporate entity or company. A corporation is the resulting legal entity that separates the firm's assets and income from its owners and investors. (Source: Investopedia)
        </dd>

        <dt>internal controls</dt>
        <dd>
        Internal controls are the mechanisms, rules, and procedures implemented by a company to ensure the integrity of financial and accounting information, promote accountability and prevent fraud. Besides complying with laws and regulations, and preventing employees from stealing assets or committing fraud, internal controls can help improve operational efficiency by improving the accuracy and timeliness of financial reporting. (Source: Investopedia)
        </dd>

        <dt>legal entity</dt>
        <dd>
        An association, corporation, partnership, proprietorship, trust, or individual that has legal standing in the eyes of law. A legal entity has legal capacity to enter into agreements or contracts, assume obligations, incur and pay debts, sue and be sued in its own right, and to be held responsible for its actions. (Source: www.businessdictionary.com)
        </dd>

        <dt>lines of credit</dt>
        <dd>
        A line of credit (LOC) is an arrangement between a financial institution—usually a bank—and a customer that establishes the maximum loan amount the customer can borrow. The borrower can access funds from the line of credit at any time as long as they do not exceed the maximum amount (or credit limit) set in the agreement and meet any other requirements such as making timely minimum payments. (Source: Investopedia)
        </dd>

        <dt>litigation</dt>
        <dd>
        Ultimate legal method for settling controversies or disputes between and among persons, organizations, and the State. In litigation process, a case (called suit or lawsuit) is brought before a court of law suitably empowered (having the jurisdiction) to hear the case, by the parties involved (the litigants) for resolution (the judgment). (Source: www.businessdictionary.com)
        </dd>

        <dt>loan covenants</dt>
        <dd>
        In legal and financial terminology, a covenant is a promise in an indenture, or any other formal debt agreement, that certain activities will or will not be carried out. Covenants in finance most often relate to terms in a financial contracting, such as a loan document or bond issue stating the limits at which the borrower can further lend. (Source: Investopedia)
        </dd>

        <dt>management reports</dt>
        <dd>
        Management reports aim at informing managers of different aspects of the business, in order to help them make better-informed decisions. Management reporting provides insights on how the company is doing, empowering decision-makers to find the right path to increase operating efficiency and make pertinent decisions to remain competitive.
        </dd>

        <dt>misdemeanor</dt>
        <dd>
        A misdemeanor is a criminal offense that is less serious than a felony and more serious than an infraction. Misdemeanors are generally punishable by a fine and incarceration in a local county jail, unlike infractions which impose no jail time.  (Source: www.findlaw.com)
        </dd>

        <dt>operating expenses</dt>
        <dd>
        An operating expense is an expense a business incurs through its normal business operations. Examples include rent, equipment, inventory costs, marketing, payroll, insurance, and funds allocated for research and development. (Source: Investopedia)
        </dd>

        <dt>operating profit</dt>
        <dd>
        Operating profit refers to an accounting metric measuring the profits a company generates from its core business functions, where the deduction of interest and taxes is excluded from the calculation. (Source: Investopedia)
        </dd>

        <dt>organizational structure</dt>
        <dd>
        An organizational structure is a system that outlines how certain activities are directed in order to achieve the goals of an organization. These activities can include rules, roles, and responsibilities. The organizational structure also determines how information flows between levels within the company. For example, in a centralized structure, decisions flow from the top down, while in a decentralized structure, decision-making power is distributed among various levels of the organization. (Source: Investopedia)
        </dd>

        <dt>patent</dt>
        <dd>
        A patent is the granting of a property right by a sovereign authority to an inventor. This grant provides the inventor exclusive rights to the patented process, design, or invention for a designated period in exchange for a comprehensive disclosure of the invention. Government agencies typically handle and approve applications for patents. In the United States, the U.S. Patent and Trademark Office (USPTO), which is part of the Department of Commerce, handles applications and grants approvals. (Source: Investopedia)
        </dd>

        <dt>perishable</dt>
        <dd>
        Article that can lose its usefulness and value if not appropriately stored or transported, or if not utilized within certain period. (Source: www.businessdictionary.com)
        </dd>

        <dt>plaintiff</dt>
        <dd>
        The party who initiates a lawsuit by filing a complaint with the clerk of the court against the defendant(s) demanding damages, performance and/or court determination of rights. (Source: www.thefreedictionary.com)
        </dd>

        <dt>private placement memorandum (PPM)</dt>
        <dd>
        An offering memorandum, also known as a private placement memorandum (PPM), is used by business owners of privately held companies to attract a specific group of outside investors. (Source: Investopedia)
        </dd>

        <dt>production expenses</dt>
        <dd>
        Production costs refer to the costs incurred by a business from manufacturing a product or providing a service. Production costs can include a variety of expenses, such as labor, raw materials, consumable manufacturing supplies, and general overhead. (Source: Investopedia)
        </dd>

        <dt>public relations</dt>
        <dd>
        The profession or practice of creating and maintaining goodwill of an organization's various publics (customers, employees, investors, suppliers, etc.), usually through publicity and other nonpaid forms of communication. (Source: www.businessdictionary.com)
        </dd>

        <dt>raw materials</dt>
        <dd>
        Basic substance in its natural, modified, or semi-processed state, used as an input to a production process for subsequent modification or transformation into a finished good. (Source: www.businessdictionary.com)
        </dd>

        <dt>regulatory entities</dt>
        <dd>
        A regulatory agency is a public authority or government agency responsible for exercising autonomous authority over some area of human activity in a regulatory or supervisory capacity. Regulatory authorities are commonly set up to enforce safety and standards, and/or to protect consumers in markets where there is a lack of effective competition or the potential for the undue exercise of market power. 
        </dd>

        <dt>revenue</dt>
        <dd>
        Revenue is the income generated from normal business operations and includes discounts and deductions for returned merchandise. It is the top line or gross income figure from which costs are subtracted to determine net income. (Source: Investopedia)
        </dd>

        <dt>sales channels</dt>
        <dd>
        A way of bringing products or services to market so that they can be purchased by consumers. A sales channel can be direct if it involves a business selling directly to its customers, or it can be indirect if an intermediary such as a retailer or dealer is involved in selling the product to customers. (Source: www.businessdictionary.com)
        </dd>

        <dt>sales management system</dt>
        <dd>
        Sales management is the process of developing a sales force, coordinating sales operations, and implementing sales techniques that allow a business to consistently meet and exceed sales targets.
        </dd>

        <dt>standard operating procedure</dt>
        <dd>
        Written procedure prescribed for repetitive use as a practice, in accordance with agreed upon specifications aimed at obtaining a desired outcome. (Source: www.businessdictionary.com)
        </dd>

        <dt>supply chain</dt>
        <dd>
        A supply chain is a network between a company and its suppliers to produce and distribute a specific product to the final buyer. This network includes different activities, people, entities, information, and resources. The supply chain also represents the steps it takes to get the product or service from its original state to the customer. (Source: Investopedia)
        </dd>

        <dt>targets and goals</dt>
        <dd>
        Business goals are written parts of a long-term vision detailing what results your company aims to accomplish and by what deadline. Targets are similar but can be considered smaller steps aligned with the details and deadlines of larger goals. An organization makes progress, and brings ultimate goals into clearer focus, as individuals and teams within the organization reach their targets. (Source: www.smallbusiness.chron.com)
        </dd>

        <dt>tolerances</dt>
        <dd>
        Tolerances are the permissible limits or limits of variation in a physical dimension, a measured value or physical property of a material, manufactured object, system, or service, or other measured value so that dimensions, properties, or conditions may vary within certain practical limits without significantly affecting the overall quality of the product or service.
        </dd>

        <dt>trade secrets</dt>
        <dd>
        A trade secret is a type of intellectual property in the form of a formula, practice, process, design, instrument, pattern, commercial method, or compilation of information not generally known or reasonably ascertainable by others by which a business can obtain an economic advantage over competitors or customers. Also known as confidential informaion.
        </dd>

        <dt>trademarks</dt>
        <dd>
        A trademark is any word, name, symbol, or design, or any combination thereof, used in commerce to identify and distinguish the goods of one manufacturer or seller from those of another and to indicate the source of the goods.
        </dd>

        <dt>warehousing</dt>
        <dd>
        Warehousing is the act of storing goods that will be sold or distributed later.
        </dd>

        <dt>working capital</dt>
        <dd>
        Working capital is the difference between a company’s current assets, such as cash, accounts receivable (customers’ unpaid bills) and inventories of raw materials and finished goods, and its current liabilities, such as accounts payable. Working capital is a measure of a company's liquidity, operational efficiency and its short-term financial health. If a company has substantial positive working capital, then it should have the potential to invest and grow. If a company's current assets do not exceed its current liabilities, then it may have trouble growing or paying back creditors, or even go bankrupt. (Source: Investopedia)
        </dd>

      </dl>
    </div>
  )
}
export default Glossary
